import {
  ASK_USER_APPROVAL_KIND,
  isClarificationToolName,
} from '../../../contracts/ask-user-details.types';
import {
  REQUEST_PROTECTED_ACTION_APPROVAL_TOOL_NAME,
  type ChildRunApproval,
} from '../../../contracts/child-run-approval.types';
import type { ToolUseItem } from '../../../contracts/harness.types';
import type { PendingToolApproval } from '../../../contracts/tool-approval.types';
import { parseToolCallDisplay } from '../../../contracts/tool-call-display';
import { COMPUTER_USE_APPROVAL_KIND } from '../timeline/derive-is-computer-use';
import { getPendingApprovalIdForItem } from './get-pending-approval-id';

/** ``null`` for child tools the child surfaces do not render. */
export const parsePendingChildRunApproval = (
  item: ToolUseItem,
  agentRunId: string
): ChildRunApproval | null => {
  const approvalId = getPendingApprovalIdForItem(item);
  if (!approvalId) return null;
  const hydratedApproval =
    item.approval?.status === 'pending' ? item.approval : undefined;
  const toolName = hydratedApproval?.tool_name ?? item.name;

  const buildPendingApproval = (fallbackApprovalKind: string): PendingToolApproval => {
    const context = hydratedApproval?.context ?? {};
    const toolCallDisplay =
      item.toolCallDisplay ?? parseToolCallDisplay(context.tool_call_display);
    return {
      approvalId,
      agentRunId,
      turnId: hydratedApproval?.turn_id,
      toolCallId: item.id,
      toolName,
      toolInput: hydratedApproval?.tool_input ?? item.input,
      redactedToolInputKeys: hydratedApproval?.redacted_tool_input_keys ?? [],
      createdAt: hydratedApproval?.created_at ?? new Date(0).toISOString(),
      approvalKind: hydratedApproval?.approval_kind ?? fallbackApprovalKind,
      context,
      ...(toolCallDisplay && { toolCallDisplay }),
    };
  };

  if (isClarificationToolName(toolName)) {
    return {
      ...buildPendingApproval(ASK_USER_APPROVAL_KIND),
      kind: 'clarification',
      toolName,
    };
  }
  if (toolName === REQUEST_PROTECTED_ACTION_APPROVAL_TOOL_NAME) {
    return {
      ...buildPendingApproval(COMPUTER_USE_APPROVAL_KIND),
      kind: 'protected_action',
      toolName,
    };
  }
  return null;
};
